import { jsx as _jsx } from "react/jsx-runtime";
// DocumentStatusContext.tsx
import { createContext, useState } from 'react';
import { DocumentStatus } from '../types/DocumentationTypes';
export const GlobalProviderContext = createContext(undefined);
export const GlobalProvider = ({ children }) => {
    const [documentStatus, setDocumentStatus] = useState(DocumentStatus.NOT_STARTED);
    return (_jsx(GlobalProviderContext.Provider, Object.assign({ value: { documentStatus, setDocumentStatus } }, { children: children })));
};
